import React from "react";
import { Table } from "antd";
import { useNavigate } from "react-router";
import { SearchOutlined } from "@ant-design/icons";

const All = () => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Address",
      dataIndex: "date",
      sorter: (a, b) => a.date - b.date,
      render: (text) => (
        <div
          type="link"
          onClick={() => navigate("/corrections_view")}
          style={{ color: "black", cursor: "pointer" }}
        >
          {text}
        </div>
      ),
    },

    {
      title: "Device#",
      dataIndex: "client",
      sorter: (a, b) => a.client - b.client,
      render: (text) => (
        <div
          type="link"
          onClick={() => navigate("/corrections_view")}
          style={{ color: "black", cursor: "pointer" }}
        >
          {text}
        </div>
      ),
    },
    {
      title: " Due",
      dataIndex: "address",
      sorter: (a, b) => a.address - b.address,
    },
    {
      title: "Type of Inspection",
      dataIndex: "agency",
      sorter: (a, b) => a.agency - b.agency,
    },

    {
      title: "",
      dataIndex: "action",
      render: () => (
        <>
          <div
            onClick={() => navigate("/corrections_view")}
            style={{ color: "black", cursor: "pointer", display: "flex" }}
          >
            <SearchOutlined className="icons-documentation1" />
          </div>
        </>
      ),
    },
  ];
  const data = [
    {
      key: "1",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
      date: "10/31/2023",
      tags: ["OPEN"],
      client: "AB Plus Cont..",
      ecb: "34567853",
      respondent: "Deep Formation",
      serverity: ["CLASS 2"],
      type: "Construction",
    },
    {
      key: "2",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
      date: "10/31/2023",
      tags: ["OPEN"],
      client: "AB Plus Cont..",
      ecb: "34567853",
      respondent: "Deep Formation",
      serverity: ["CLASS 2"],
      type: "Construction",
    },
    {
      key: "3",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
      date: "10/31/2023",
      tags: ["OPEN"],
      client: "AB Plus Cont..",
      ecb: "34567853",
      respondent: "Deep Formation",
      serverity: ["CLASS 2"],
      type: "Construction",
      path: "/",
    },
  ];

  return (
    <>
      <div style={{ padding: "20px" }}>
        <Table columns={columns} dataSource={data} size="middle" />
      </div>
    </>
  );
};

export default All;
